import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { userAuthSelector } from 'Store/modules/auth/selectors';
import { setHotjarIdentify, setHotjarScript } from 'Config/hotjar';
import { isProduction } from 'Config';

const SCRIPT_ID = 'hotjar-script';
const IFRAME_NAME = '_hjRemoteVarsFrame';

const useHotjar = (pathname: string): void => {
  const user = useSelector(userAuthSelector);

  useEffect(() => {
    if (isProduction()) {
      setHotjarScript();
      if (user) {
        const { id: userId, email } = user;
        setHotjarIdentify(userId, email);
      }
    }
    return () => {
      const script = document.querySelectorAll(`#${SCRIPT_ID}`);
      const iframe = document.getElementsByName(IFRAME_NAME);
      if (script) {
        script.forEach(n => n.remove());
      }
      if (iframe) {
        iframe.forEach(n => n.remove());
      }
    };
  }, [pathname]);
};

export default useHotjar;
